
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { newsItems } from '../../mocks/news';

export default function NewsPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header scrolled={scrolled} />
      <main className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
              NEWS
            </h1>
            <p className="text-gray-600">
              最新のお知らせ・ニュースをお届けします
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {newsItems.length > 0 ? (
              <div className="space-y-0">
                {newsItems.map((item, index) => (
                  <Link
                    key={index}
                    to={`/news/detail?id=${item.id}`}
                    className="block border-t border-gray-200 py-8 hover:bg-gray-50 transition-colors cursor-pointer group"
                  >
                    <div className="flex flex-col md:flex-row md:items-center gap-4">
                      <time className="text-sm text-gray-500 font-medium md:w-32 flex-shrink-0">
                        {item.date}
                      </time>
                      <div className="flex-1">
                        <span className="inline-block px-3 py-1 bg-gray-100 text-xs font-medium text-gray-700 rounded-full mb-3">
                          {item.category}
                        </span>
                        <h2 className="text-lg font-medium text-gray-900 group-hover:text-gray-600 transition-colors">
                          {item.title}
                        </h2>
                      </div>
                      <i className="ri-arrow-right-line text-xl text-gray-400 group-hover:text-gray-600 transition-colors hidden md:block"></i>
                    </div>
                  </Link>
                ))}
                <div className="border-t border-gray-200"></div>
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-gray-500">現在、ニュースはありません。</p>
              </div>
            )}
          </div>

          <div className="mt-16 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-black transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              ホームに戻る
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
